import type { IconName } from '@pulsepointinc/bi-components';
import type { PermissionSubject } from '../../../hooks/usePermissions';
import type { WorkspaceTypeID } from '../workspaces';

export enum LookerDataType {
  DATE_RANGE = 'date_range',
  RANGE = 'range',
  STRING = 'string',
}

export enum FilterConfigNames {
  HCPExplorer = 'hcp_explorer',
  Throtle = 'throtle_analytics',
  HCPExpansion = 'hcp_audience_expansion',
  ListMatching = 'list_matching',
  DTC = 'dtc_audiences',
  HCPSiteAnalytics = 'hcp_site_analytics',
  BrandExplorer = 'brand_explorer',
}

export interface FilterConfigItemBasic {
  advancedFilter: boolean;
  beAccessible?: boolean;
  correspondingCrossFilter?: string;
  dataType?: LookerDataType;
  disabled?: boolean;
  filterName: string;
  filterToPreserveOnReset?: boolean;
  friendlyName: string;
  icon?: IconName;
  lookmlAddress: string;
  maskTreatment?: string;
  multipleSelections: boolean;
  removeDeleteButton?: boolean;
  requiredPermission?: PermissionSubject;
  semanticSearch?: boolean;
  sendAdvID?: boolean;
  setExpression?: boolean;
  setFilterForCustomComponent?: boolean;
  toggleable: boolean;
  tooltip?: string;
  type: string;
  visible?: boolean;
  secondaryFilters?: string[];
  auxiliaryFilters?: string[];
}

export interface GetFilterConfigResponse {
  configuration: FilterConfigItemBasic[];
  eventID: string;
}

export interface GetFilterConfigRequest {
  workspaceTypeId?: WorkspaceTypeID;
  fileName?: string;
  sourcingMethod?: 'typeID' | 'fileName';
}

export interface GetFilterConfigQueryResponse {
  filterConfig: FilterConfigItemBasic[];
}
